// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"3d2034db","98":"f554b1f8","498":"ba52f8f9","532":"6b49ccd4","804":"26c477cc","928":"c5c5c629","950":"fcda67ca","958":"b4709ab8"}[chunkId] + ".chunk.js";
};